/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_Frame_TrueInputs */



/**
* | output |
* | --- |
* | "true" |
*
* @param {Dialogue_List_Export_Drop_Frame_TrueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame_true = /** @type {((inputs?: Dialogue_List_Export_Drop_Frame_TrueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_Frame_TrueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("vrai")
	if (locale === "de") return /** @type {LocalizedString} */ ("WAHR")
	if (locale === "it") return /** @type {LocalizedString} */ ("VERO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("истинный")
	if (locale === "es") return /** @type {LocalizedString} */ ("verdadero")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("真的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("真実")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("verdadeiro")
	return /** @type {LocalizedString} */ ("true")
});